"use client";

import { Separator } from "@/components/ui/separator";
import BatchTaskToolbar from "./BatchTaskToolbar";
import BatchTaskTable from "./BatchTaskTable";
import BatchTaskDetailPanel from "./BatchTaskDetailPanel";

const BatchTaskWorkspace: React.FC = () => {
  return (
    <div className="flex flex-col gap-4 flex-1 min-h-0">
      <BatchTaskToolbar />

      <div className="flex-1 min-h-0 flex flex-col lg:flex-row rounded-md border bg-card overflow-hidden">
        <div className="flex-[0.58] min-h-[280px] lg:min-h-0 lg:h-auto lg:max-h-none max-h-[60vh] flex flex-col">
          <BatchTaskTable />
        </div>

        <div className="block lg:hidden">
          <Separator className="opacity-60" />
        </div>
        <div className="hidden lg:block">
          <Separator orientation="vertical" className="h-full opacity-60" />
        </div>

        <div className="flex-[0.42] min-h-[320px] lg:min-h-0 flex flex-col">
          <BatchTaskDetailPanel />
        </div>
      </div>
    </div>
  );
};

export default BatchTaskWorkspace;
